<span class="d-inline-flex align-items-center gap-5" *ngIf="icon()">
  <mat-icon
    class="priority-icon f-18 d-flex align-items-center justify-content-center flex-static-space"
    [style.color]="color()"
    [matTooltip]="hasTooltip() ? (labelKey()! | translate) : ''"
    [matTooltipDisabled]="!hasTooltip()"
    >{{ icon() }}</mat-icon
  >
  <span class="priority-label" *ngIf="showLabel()">{{ labelKey()! | translate }}</span>
</span>
